export default __webpack_public_path__ + "static/aikido-luc-8179a2961876692eb85ce024a4d24812.jpg";